import { render, staticRenderFns } from "./reported.vue?vue&type=template&id=1875f8e1&scoped=true"
import script from "./reported.vue?vue&type=script&lang=ts"
export * from "./reported.vue?vue&type=script&lang=ts"
import style0 from "./reported.vue?vue&type=style&index=0&id=1875f8e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875f8e1",
  null
  
)

export default component.exports